import { render } from "./InsuranceAgentsOverview.vue?vue&type=template&id=360548ac"
import script from "./InsuranceAgentsOverview.vue?vue&type=script&lang=js"
export * from "./InsuranceAgentsOverview.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/production/releases/342/dashboard.jumpfeed.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__